module.exports = __webpack_public_path__ + "img/dubbele_plooi_retour.ece5e028.png";